import { memo } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import MarkdownRender from 'LuxKit/MarkdownRender'
import List from 'components/Common/List'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

const StyledList = styled(List)`
  margin-top: 0;
`

interface Props {
  finePrint: App.BedbankPropertyFinePrint
}

function PropertyFinePrint({
  finePrint,
}: Props) {
  const intl = useIntl()
  return <Group gap={20} direction="vertical">
    {(finePrint.checkIn?.beginTime || finePrint.checkIn?.endTime) &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">{intl.formatMessage({
          id: 'Q8kB8A0QCn5ojp46zki2',
          defaultMessage: 'Check-in',
        })}
        </BodyText>
        {finePrint.checkIn.beginTime && <BodyText variant="medium">{intl.formatMessage(
          {
            id: 'MYCqv8L8bZpjkjj5ug0s',
            defaultMessage: 'Check-in starts at {time}',
          },
          { time: finePrint.checkIn.beginTime },
        )}
        </BodyText>}
        {finePrint.checkIn.endTime && <BodyText variant="medium">{intl.formatMessage(
          {
            id: 'u5FuXahdn6g1oOe3mTsK',
            defaultMessage: 'Check-in ends at {time}',
          },
          { time: finePrint.checkIn.endTime },
        )}
        </BodyText>}
      </div>}
    {finePrint.checkOut?.time &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">{intl.formatMessage({
          id: 'F126sr4mcXs45cLhiUIZ',
          defaultMessage: 'Check-out',
        })}
        </BodyText>
        <BodyText variant="medium">{intl.formatMessage(
          {
            id: 'Qh-UOxoDKSGYDrRr8fnq',
            defaultMessage: 'Check-out before {time}',
          },
          { time: finePrint.checkOut.time },
        )}
        </BodyText>
      </div>}
    {(finePrint.checkIn?.specialInstructions || finePrint.checkIn?.instructions) &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">{intl.formatMessage({
          id: '-DqDtfqi6I3I5HTH1cd_',
          defaultMessage: 'Special check-in instructions',
        })}
        </BodyText>
        {finePrint.checkIn.specialInstructions && <BodyText variant="medium">{finePrint.checkIn.specialInstructions}</BodyText>}
        {finePrint.checkIn.instructions && <BodyText variant="medium" as="p">{finePrint.checkIn.instructions}</BodyText>}
      </div>}
    {!!finePrint.pets?.length &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">{intl.formatMessage({
          id: 'yDa0vW5faJH-cmEG3D-t',
          defaultMessage: 'Pets',
        })}
        </BodyText>
        <StyledList spaced>
          {finePrint.pets.map(item => <BodyText variant="medium" as="li" key={item}>{item}</BodyText>)}
        </StyledList>
      </div>}
    {(finePrint.fees?.optional || finePrint.fees?.mandatory) &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">{intl.formatMessage({
          id: 'E8ryTnKeOVbTu9w20AzX',
          defaultMessage: 'Fees',
        })}
        </BodyText>
        {finePrint.fees.mandatory && <MarkdownRender type="compact" fontSize="medium" content={finePrint.fees.mandatory} />}
        {finePrint.fees.optional && <MarkdownRender type="compact" fontSize="medium" content={finePrint.fees.optional} />}
      </div>}
    {finePrint.policies?.knowBeforeYouGo &&
      <div>
        <BodyText variant="medium" as="h4" weight="bold">{intl.formatMessage({
          id: 'lb6df1TwXrZjcAod8T8d',
          defaultMessage: 'Know Before You Go',
        })}
        </BodyText>
        <MarkdownRender type="compact" fontSize="medium" content={finePrint.policies.knowBeforeYouGo} />
      </div>}
  </Group>
}

export default memo(PropertyFinePrint)
